import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProgramArchiveOption } from 'app/library/module/enums/program-archive-option.enum';

export interface IArchiveProgramDialogResult {
    archiveOption: ProgramArchiveOption;
}

@Component({
    selector: 'app-archive-program-dialog',
    templateUrl: './archive-program-dialog.component.html',
    styleUrls: ['./archive-program-dialog.component.scss'],
})
export class ArchiveProgramDialogComponent implements OnInit {
    form: FormGroup;

    readonly archiveOptionAll = ProgramArchiveOption.ArchiveAll;
    readonly archiveOptionOnly = ProgramArchiveOption.ArchiveOnlyProgram;

    constructor(public dialogRef: MatDialogRef<ArchiveProgramDialogComponent>, private _fb: FormBuilder) {}

    ngOnInit(): void {
        this.form = this._fb.group({
            archive_option: [this.archiveOptionOnly],
        });
    }

    confirm(): void {
        const archiveOption = this.form.get('archive_option').value as ProgramArchiveOption;
        this.dialogRef.close({ archiveOption } as IArchiveProgramDialogResult);
    }
}
